<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav :title="$t('闪兑.闪兑中心')" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
				<div class="swap-item1-bg-image p-40">
					<div class="flex items-center justify-between">
						<div class="flex items-center">
							<span class="text-40 font-bold text-white">RGT</span>
							<img class="mx-20 w-28 h-28" src="@/assets/images/pages/swap/qh.png" alt="" />
							<span class="text-40 font-bold text-white">ROON {{$t('闪兑.闪兑')}}</span>
						</div>
						<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
							style="border-color: #2DFDFF; background-color: #2DFDFF20;">
							<div class="w-8 h-8 rounded-full" style="background-color: #2DFDFF;"></div>
							<span class="ml-10 text-20" style="color: #2DFDFF;">{{$t('闪兑.即时互换')}}</span>
						</div>
					</div>
					<div class="mt-20">
						<span class="text-24 text-#ccc">{{$t('闪兑.快速兑换 · 实时到账 · 20:1比例')}}</span>
					</div>
					<div class="mt-30 flex items-center">
						<img class="w-22 h-22" src="@/assets/images/pages/swap/sd.png" alt="" />
						<span class="ml-10 text-24 text-#ccc">{{$t('闪兑.极速闪兑')}}</span>
						<img class="ml-20 w-22 h-22" src="@/assets/images/pages/swap/aq.png" alt="" />
						<span class="ml-10 text-24 text-#ccc">{{$t('闪兑.安全可靠')}}</span>
					</div>
				</div>
				<div class="mt-30 flex items-center justify-between">
					<div class="swap-item2-bg-image p-30">
						<div class="flex items-center justify-between">
							<span class="text-24 text-#ccc">{{$t("闪兑.RGT余额")}}</span>
							<img class="w-50 h-50" src="@/assets/images/pages/swap/rgt.png" alt="" />
						</div>
						<div class="mt-30">
							<span class="text-46 font-bold" style="color: #2DFDFF;">{{rgt_swap}}</span>
						</div>
						<div class="mt-20">
							<span class="text-20 text-#eee">{{$t("闪兑.可用于闪兑")}}</span>
						</div>
					</div>
<!--					<div class="swap-item3-bg-image  p-30">-->
					<div class="swap-item3-bg-image  p-30" @click="goToLock">
						<div class="flex items-center justify-between">
							<span class="text-24 text-#ccc">{{$t("闪兑.ROON余额")}}</span>
							<img class="w-50 h-50" src="@/assets/images/pages/swap/roon.png" alt="" />
						</div>
						<div class="mt-30">
							<span class="text-46 font-bold" style="color: #EB470C;">{{all_surplus_roon}}</span>
						</div>
						<div class="mt-20">
							<span class="text-20 text-#eee">{{$t("闪兑.闪兑获得")}}</span>
						</div>
					</div>
				</div>
				<div class="mt-20 bg-white/10 rounded-20 p-20 flex items-center">
					<img class="w-88 h-88" src="@/assets/images/pages/swap/dj.png" alt="" />
					<div class="ml-20 flex-1">
						<div class="flex items-center justify-between">
							<div>
								<span class="text-28 text-white">{{$t("闪兑.节点等级")}}</span>
							</div>
							<div>
								<span class="text-24 text-#999">{{$t("闪兑.闪兑优惠")}}</span>
							</div>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div>
								<span class="text-40 text-warning font-blod">{{node_name}}</span>
							</div>
<!--							<div>-->
<!--								<span class="text-24 " style="color: #67E7F8;">0{{$t("闪兑.手续费")}}</span>-->
<!--							</div>-->
						</div>
					</div>
				</div>
				<div class="mt-20 bg-white/10 rounded-20 p-20 flex items-center">
					<img class="w-40 h-40" src="@/assets/images/pages/swap/bl.png" alt="" />
					<div class="ml-20 flex-1">
						<div class="flex items-center justify-between">
							<div>
								<span class="text-28 text-white">{{$t("闪兑.闪兑比例")}}</span>
							</div>
<!--							<div>-->
<!--								<span class="text-24 text-#999">{{$t("闪兑.闪兑优惠")}}</span>-->
<!--							</div>-->
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div>
								<span class="text-30 font-blod" style="color: #67E7F8;">20RGT=1 ROON</span>
							</div>
<!--							<div>-->
<!--								<span class="text-24 " style="color: #67E7F8;">0{{$t("闪兑.手续费")}}</span>-->
<!--							</div>-->
						</div>
					</div>
				</div>
				<div class="mt-20 bg-white/10 rounded-20 p-30">
					<div class="">
						<span class="text-36 text-white font-bold">{{$t("闪兑.闪兑数量")}}</span>
					</div>
					<div class="mt-20 h-110 rounded-20 flex items-center justify-between px-30"
						style="background-color: #0F0F10;">
						<input class="flex-1 text-32 text-white" v-model="form.amount" @input="handleInputTwo" type="text" :placeholder="$t('闪兑.输入RGT数量')" />
						<span class="text-32 text-primary" style="color: #2DFDFF;">RGT</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<span class="text-24 text-#999">{{$t("闪兑.最低")}} 1 RGT</span>
						<div class="flex items-center">
							<span class="text-24 text-#999">{{$t("闪兑.余额")}}</span>
							<span class="text-24" style="color: #2DFDFF;">{{rgt_swap}} RGT</span>
						</div>
					</div>
<!--					<div class="mt-20 flex items-center justify-between">-->
<!--						<div @click="selectAmount(item.num)" v-for="(item, index) in numberList" :key="index"-->
<!--							:class="[form.amount == item.num ? 'bg-primary text-white' : 'bg-#1B1B1B text-#ccc']"-->
<!--							class="w-110 h-80 rounded-20 flex items-center justify-center ">-->
<!--							<span class="text-28">{{item.num}}</span>-->
<!--						</div>-->
<!--					</div>-->
					<div class="mt-30 rounded-20 bg-white/10 py-30 flex items-center justify-center">
						<div>
							<div class="flex items-center justify-center">
								<span class="text-24 text-#999">{{$t('闪兑.将获得')}}</span>
							</div>
							<div class="flex items-start justify-center mt-20">
								<div class="text-right">
									<div>
										<span class="text-50 font-bold" style="color: #2DFDFF">{{form.amount}}</span>
									</div>
									<div>
										<span class="text-26 " style="color: #2DFDFF">RGT</span>
									</div>
								</div>
								<img class="mx-30 w-50 h-50" src="@/assets/images/pages/swap/hz.png" alt="" />
								<div class="text-left">
									<div>
										<span class="text-50 font-bold" style="color: #EB470C">{{form.dd_roon}}</span>
									</div>
									<div>
										<span class="text-26 " style="color: #EB470C">ROON</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-center">
<!--						<div @click="showAmountPopup = true"-->
						<div @click="buy"
							class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
							<span class="text-32 text-white">{{$t('闪兑.立即闪兑')}}</span>
						</div>
					</div>
				</div>
				<div class="mt-30 bg-white/10 p-30 rounded-20">
					<div class="">
						<span class="text-36 text-white font-bold">{{$t("闪兑.闪兑说明")}}</span>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 flex items-center p-20">
						<div class="w-70 h-70">
							<img class="w-full h-full" src="@/assets/images/pages/swap/sm1.png" alt="" />
						</div>
						<div class="ml-20">
							<div>
								<span class="text-24 text-white">{{$t("闪兑.极速到账")}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#999">{{$t("闪兑.闪兑后ROON立即到账，无需等待")}}</span>
							</div>
						</div>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 flex items-center p-20">
						<div class="w-70 h-70">
							<img class="w-full h-full" src="@/assets/images/pages/swap/sm2.png" alt="" />
						</div>
						<div class="ml-20">
							<div>
								<span class="text-24 text-white">{{$t("闪兑.安全保障")}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#999">{{$t("闪兑.智能合约保障，资金安全可靠")}}</span>
							</div>
						</div>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 flex items-center p-20">
						<div class="w-70 h-70">
							<img class="w-full h-full" src="@/assets/images/pages/swap/sm3.png" alt="" />
						</div>
						<div class="ml-20">
							<div>
								<span class="text-24 text-white">{{$t("闪兑.零手续费")}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#999">{{$t("闪兑.享受零手续费特权")}}</span>
							</div>
						</div>
					</div>

				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<!-- <menu-bar activeMenu="node"></menu-bar> -->
		</template>
		<template v-slot:popup>
			<van-popup v-model="showAmountPopup" position="center" round>
				<div class="w-690">
					<div class="flex items-center justify-center relative h-200">
						<img class="absolute w-200 h-200" style="z-index: 100;" src="@/assets/images/common/success.png"
							alt="" />
					</div>
					<div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30" style="margin-top: -98rem;">
						<div class="flex items-center justify-center mt-20">
							<span class="text-36 text-white">{{$t("闪兑.闪兑成功")}}</span>
						</div>
						<div class="flex items-center justify-center mt-20">
							<span class="text-26 text-#999">{{$t("闪兑.ROON已成功转入您的钱包")}}</span>
						</div>
						<div class="h-110 rounded-18 bg-#1B1B1B flex items-center justify-between mt-20 mx-20 px-30">
							<span class="text-26 text-white">{{$t("闪兑.消耗RGT")}}</span>
							<div class="flex items-center">
								<img class="w-40 h-40" src="@/assets/images/pages/swap/rgt.png" alt="" />
								<span class="ml-20 text-36" style="color: #2DFDFF;">{{form.amount}} RGT</span>
							</div>
						</div>
						<div class="h-110 rounded-18 bg-#1B1B1B flex items-center justify-between mt-20 mx-20 px-30">
							<span class="text-26 text-white">{{$t("闪兑.获得ROON")}}</span>
							<div class="flex items-center">
								<img class="w-40 h-40" src="@/assets/images/pages/swap/roon.png" alt="" />
								<span class="ml-20 text-36" style="color: #EB470C;">{{form.dd_roon}} ROON</span>
							</div>
						</div>
						<div class="mt-40 flex items-center justify-center">
							<div @click="showAmountPopup = false" class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
								<span class="text-32 text-white">{{$t('闪兑.确认')}}</span>
							</div>
						</div>
					</div>
				</div>

			</van-popup>

			<!-- 不可关闭的支付 Loading 遮罩：发起支付后显示，收到交易哈希后关闭 -->
			<van-overlay :show="paying" :z-index="2000" lock-scroll>
				<div class="w-full h-full flex items-center justify-center">
					<div class="px-40 py-30 bg-#1B1B1B rounded-20 flex items-center">
						<van-loading type="spinner" color="#2DFDFF" size="28px" />
						<span class="ml-16 text-28 text-white">交易提交中，请稍候…</span>
					</div>
				</div>
			</van-overlay>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBar from '@/components/menu-bar/menu-bar.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBar,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				typeList: [],
				queryInfo: {
					page: 1,
					type: 1
				},
				min_number: 0,
				node_allocate: 0,
				node_release: 0,
				node_low_pool: 1995,
				node_day: 0,
				node_number: 0,
				node_has: 0,
				node_price: 0,
				node_progress: 0,
				node_surplus_number: 0,
				last_pledge_id: 0,
				last_pledge_time: "",
                all_surplus_roon: "",
                roon_number: "100000",
                node_name: "",
                rgt_swap: "",
				mining_contract: "",
				last_pledge_usdt: "",
				last_pledge_name: "",
				address: "",
                total_address: "",
				show_address: "",
				order_id: "",
				users_id: "",
				contract_address: "0xf3708a77ea0282de751244194c304554d5a5d7ed",
				usdt_address: "0x55d398326f99059fF775485246999027B3197955",
				web3Provider: null,
				web3: null,
				list: [],
                amountList: [],
                showAmountPopup: false,
                // 支付进行中的不可关闭 loading 遮罩
                paying: false,
                canGo: true,
                form: {
                    type: 1,
                    amount: 0,
                    dd_roon: 0,
                    amount_id: 0
                },
				// 是否购买
				isBuy: true,
				numberList: [{
						id: 1,
						num: 100
					},
					{
						id: 2,
						num: 500
					},
					{
						id: 3,
						num: 1000
					},
					{
						id: 4,
						num: 2000
					},
					{
						id: 5,
						num: 5000
					},

				]
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
			activeType() {
				let item = {};
				item = this.typeList.find(item => item.id == this.queryInfo.type) || {};
				return item;
			},
			activeAmount() {
				let item = {};
				item = this.amountList.find(item => item.id == this.form.amount_id) || {};
				return item;
			}
		},
		created() {
			let vm = this
			if (window.ethereum) {
				vm.web3Provider = window.ethereum
				vm.web3 = new Web3(vm.web3Provider);
			}
			vm.getList();
		},
		methods: {
            goToLock() {
                this.$router.push({
                    path: '/lock'
                })
            },
			getList() {
				let vm = this
				getShowAddress()
				ajaxData("/rgt/swap").then(res => {
					console.log(res)
                    vm.address = res.data.address;
                    vm.rgt_swap = res.data.rgt_swap;
                    vm.node_name = res.data.node_name;
                    vm.total_address = res.data.total_address;
                    vm.roon_number = res.data.roon_number;
                    vm.all_surplus_roon = res.data.all_surplus_roon;

					// vm.getUserNodePurchaseStatus()
				})
			},
			async getUserNodePurchaseStatus() {
				const vm = this;
				const contract = new vm.web3.eth.Contract(Mining_Abi, vm.mining_contract);
				let data = await contract.methods.getUserNodePurchaseStatus(vm.address).call();
				console.log(data)
				console.log(data.nodeCount)
			},
            handleInputTwo(){
                const vm = this;
                let val = String(vm.form?.amount ?? '');
                // 仅保留数字（不允许小数点与其他字符）
                val = val.replace(/\D/g, '');
                // 解析后的数值可能出现 NaN 的情况，需回退
                const parsed = parseInt(val, 10);
                if (!val.length || Number.isNaN(parsed) || !Number.isFinite(parsed)) {
                    vm.form.amount = '';
                    vm.form.dd_roon = 0;
                    return;
                }
                vm.form.amount = parsed;
                vm.form.dd_roon = parsed / 20;
            },
            async buy() {
                const vm = this;
                try {
                    if (!vm.web3 || !vm.address) {
                        vm.$message.error(utils.$t("吐司.请在钱包中打包"));
                        return;
                    }

                    // 校验当前网络是否为 ROON 主链（chainId = 1314520）
                    const currentChainId = await vm.web3.eth.getChainId().catch(() => null);
                    if (currentChainId !== 1492) {
                        vm.$message.error("请切换到 ROON 主链");
                        return;
                    }

                    // 统一从钱包拉取当前账户，兼容 TokenPocket/MetaMask/OKX
                    let walletAccount = null;
                    try {
                        if (window?.ethereum?.request) {
                            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                            walletAccount = accounts && accounts[0] ? accounts[0] : null;
                        } else {
                            const accounts = await vm.web3.eth.getAccounts();
                            walletAccount = accounts && accounts[0] ? accounts[0] : null;
                        }
                    } catch (e) {
                        vm.$message.error("请连接钱包");
                        return;
                    }
                    if (!walletAccount) {
                        vm.$message.error("请连接钱包");
                        return;
                    }
                    // 使用钱包当前账户作为交易发起方
                    vm.address = walletAccount;

                    if (vm.form.amount <= 0){
                        vm.$message.error("请输入兑换金额");
                        return;
                    }

                    // 校验：RGT 余额是否足够
                    const rgtAvailable = parseFloat(vm.rgt_swap || 0);
                    const rgtToSwap = parseFloat(vm.form.amount || 0);
                    if (!Number.isFinite(rgtAvailable) || rgtAvailable < rgtToSwap) {
                        vm.$message.error(utils.$t('吐司.余额不足'));
                        return;
                    }

                    // 纯地址转账：仅 from/to/value，不携带任何合约数据
                    const recipient = vm.total_address;
                    if (!recipient) {
                        vm.$message.error(utils.$t("吐司.收款地址无效"));
                        return;
                    }

                    // 金额来源：优先取表单选择，其次默认值
                    let amountEth = parseFloat(vm.roon_number);
                    // if (!Number.isFinite(amountEth) || amountEth <= 0) {
                    //     amountEth = 0.001;
                    // }
                    // amountEth = 0.0013
                    const weiValue = vm.web3.utils.toWei(amountEth.toString(), 'ether');

                    // 预检：目标是否为合约地址（纯地址转账期望为 EOA）
                    try {
                        const code = await vm.web3.eth.getCode(recipient);
                        if (code && code !== '0x' && code !== '0x0') {
                            console.warn('目标为合约地址，纯地址转账可能失败（无 payable receive/fallback）');
                        }
                    } catch (e) {
                        console.warn('getCode 失败：', e?.message || e);
                    }

                    // 预检：余额是否足够（含手续费的粗略估算）
                    try {
                        const toBN = vm.web3.utils.toBN;
                        const balanceWei = await vm.web3.eth.getBalance(vm.address);
                        console.log("balanceWei",balanceWei)
                        const gasPrice = await vm.web3.eth.getGasPrice().catch(() => vm.web3.utils.toWei('1', 'gwei'));
                        const feeEstimate = toBN(gasPrice).mul(toBN(21000));
                        const need = toBN(weiValue).add(feeEstimate);
                        if (toBN(balanceWei).lt(need)) {
                            vm.$message.error(utils.$t('吐司.余额不足含手续费'));
                            return;
                        }
                    } catch (e) {
                        console.warn('余额/手续费预检失败，继续尝试发送：', e?.message || e);
                    }

                    // 展示不可关闭的 loading 遮罩
                    vm.$message.success("请在钱包确认交易");
                    vm.paying = true;

                    // 使用事件回调：在拿到交易哈希时关闭 loading
                    // 一些钱包（如 TokenPocket）对于 gas/gasPrice 更为严格，尽量显式提供
                    let gasPriceHex;
                    try {
                        const gasPrice = await vm.web3.eth.getGasPrice();
                        gasPriceHex = vm.web3.utils.toHex(gasPrice);
                    } catch {
                        gasPriceHex = vm.web3.utils.toHex(vm.web3.utils.toWei('63', 'gwei'));
                    }
                    let gasLimitHex;
                    try {
                        const gas = await vm.web3.eth.estimateGas({ from: vm.address, to: recipient, value: weiValue });
                        gasLimitHex = vm.web3.utils.toHex(gas);
                    } catch {
                        gasLimitHex = vm.web3.utils.toHex(21000);
                    }

                    const txParams = {
                        from: vm.address,
                        to: recipient,
                        value: vm.web3.utils.toHex(weiValue),
                        gasPrice: gasPriceHex,
                        gas: gasLimitHex,
                    };

                    vm.web3.eth.sendTransaction(txParams)
                    .on('transactionHash', (hash) => {
                        console.log('交易哈希:', hash);

                        vm.paying = false;

                        ajaxData("/rgt/swap/post",{
                            hash:hash,
                            rgt:vm.form.amount,
                        }).then(res => {
                            console.log(res)
                            // 收到哈希后关闭 loading

                            vm.showAmountPopup = true;
                            vm.$message.success(utils.$t("吐司.购买成功"));
                            vm.getList()
                            // vm.getUserNodePurchaseStatus()
                        })
                    })
                    .on('receipt', (receipt) => {
                        console.log('主币支付成功:', receipt?.transactionHash || receipt);
                    })
                    .on('error', (err) => {
                        const original = err?.data?.originalError?.message || err?.data?.message || err?.message;
                        console.error('交易失败:', err);
                        vm.$message.error(original || utils.$t("吐司.购买失败"));
                        vm.paying = false;
                    });
                } catch (err) {
                    // 输出更详细的 RPC 错误信息，便于定位问题
                    const original = err?.data?.originalError?.message || err?.data?.message || err?.message;
                    console.error('交易失败:', err);
                    vm.$message.error(original || utils.$t("吐司.购买失败"));
                    vm.paying = false;
                }
            },

			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			selectAmount(number) {
				this.form.amount = parseInt(number);
				this.form.dd_roon = this.form.amount / 20;

				// this.form.amount_id = item.id;
				// this.showAmountPopup = false;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	.swap-item1-bg-image {
		width: 690rem;
		height: 240rem;
		background-image: url("~@/assets/images/pages/swap/img_banner.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.swap-item2-bg-image {
		width: 326rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/swap/item1Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.swap-item3-bg-image {
		width: 326rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/swap/item2Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}
</style>
